import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function FinalCTA() {
  return <section className="py-12 md:py-20 lg:py-24 bg-clinical-deep text-white" data-id="element-82">
      <div className="max-w-[1000px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-83">
        <div className="text-center mb-8 md:mb-10" data-id="element-84">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-[10px] sm:text-xs font-semibold tracking-[0.22em] uppercase text-clinical-accent mb-4" data-id="element-85">
            Última oportunidad
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl sm:text-4xl md:text-5xl font-black mb-7 md:mb-9 leading-[1.05] text-white uppercase" data-id="element-86">
            El precio{' '}
            <span className="accent-italic-gold normal-case" data-id="element-87">cierra en</span>
          </motion.h2>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="flex justify-center mb-8 md:mb-12" data-id="element-88">
            <Countdown data-id="element-89" />
          </motion.div>
        </div>

        <div className="max-w-md mx-auto mb-8 md:mb-10" data-id="element-90">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl p-6 md:p-8 flex flex-col h-full text-clinical-deep relative text-center" data-id="element-91">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-clinical-accent text-clinical-deep text-[10px] font-bold uppercase tracking-[0.22em] py-1.5 px-3 rounded-full whitespace-nowrap" data-id="element-92">
              Recomendado
            </div>

            <h4 className="text-lg md:text-xl font-black mb-2 mt-2 uppercase" data-id="element-93">
              Mega Pack Enfermería
            </h4>
            <p className="text-clinical-ink/70 text-sm mb-5" data-id="element-94">
              6 Tomos + 6 Bonos
            </p>

            <div className="mb-6" data-id="element-95">
              <span className="line-through text-clinical-ink/40 mr-3 text-base font-medium" data-id="element-96">
                $51.000
              </span>
              <span className="text-3xl md:text-4xl font-black text-clinical-deep" data-id="element-97">
                $21.990{' '}
                <span className="text-base font-semibold text-clinical-ink/60" data-id="element-98">
                  ARS
                </span>
              </span>
            </div>

            <a href="https://megapackenfermeria.impultienda.ar/checkout" target="_top" className="mt-auto w-full py-3.5 md:py-4 rounded-full bg-clinical-accent text-clinical-deep font-bold text-sm md:text-base hover:bg-clinical-accentLight active:scale-[0.98] transition-all text-center inline-flex justify-center items-center gap-2 uppercase tracking-wide touch-manipulation" data-id="element-99">
              Quiero mi Mega Pack
            </a>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="flex flex-wrap justify-center items-center gap-x-3 gap-y-2 text-xs sm:text-sm text-white/60 max-w-3xl mx-auto text-center" data-id="element-100">
          <div className="flex items-center gap-1.5" data-id="element-101">
            <Lock size={14} className="text-white/50" data-id="element-102" />
            <span data-id="element-103">Pago 100% seguro</span>
          </div>
          <span className="text-white/20" data-id="element-104">·</span>
          <div className="flex items-center gap-1.5" data-id="element-105">
            <ShieldCheck size={14} className="text-white/50" data-id="element-106" />
            <span data-id="element-107">Acceso en 5 minutos</span>
          </div>
          <span className="text-white/20" data-id="element-108">·</span>
          <div className="flex items-center gap-1.5" data-id="element-109">
            <ShieldCheck size={14} className="text-white/50" data-id="element-110" />
            <span data-id="element-111">Garantía 7 días</span>
          </div>
          <span className="text-white/20" data-id="element-112">·</span>
          <div className="flex items-center gap-1.5" data-id="element-113">
            <CreditCard size={14} className="text-white/50" data-id="element-114" />
            <span data-id="element-115">Mercado Pago</span>
          </div>
        </motion.div>
      </div>
    </section>;
}